<template>
<!--   <tab-pane :title="'tab-'+index" :key="'tab-'+index"> -->
<tab-pane :title="title" :key="key"> 
    <b-icon slot="title" :icon="icon" scale='1.1'></b-icon> 
    {{ index }}
       {{ title }}
</tab-pane>

</template>

<script>
export default {
    name: 'Tab',
    props: ['index', 'icon'],
    computed: {
        title(){
            return "tab-" + this.index;
        },
        key(){
            return "tab-" + this.index;
        }
  
    }
}
</script>